var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuccessContactUsForm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 378 199"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#successContactUsForm_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3B9DFF",
  d: "M223.325 62.273H.185v110.74h223.14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3B9DFF",
  d: "M95.755 166.183c-1.52 3-47.79 31.85-47.79 31.85l6.83-35.65z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#212D56",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.27,
  d: "M79.265 108.423h104.76M79.265 127.013h80.42M43.085 136.033c9.195 0 16.65-7.454 16.65-16.65s-7.455-16.65-16.65-16.65c-9.196 0-16.65 7.455-16.65 16.65 0 9.196 7.454 16.65 16.65 16.65"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3071CE",
  d: "M138.704 62.783s10.74 70.911 84.36 83.111v-83.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#212D56",
  d: "M327.924.033h-128.69c-27.547 0-49.88 22.332-49.88 49.88s22.333 49.88 49.88 49.88h128.69c27.548 0 49.88-22.332 49.88-49.88S355.472.033 327.924.033"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#212D56",
  d: "M281.915 96.583c1.78 3.56 56.19 37.46 56.19 37.46l-8-41.92z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.32,
  d: "M226.944 40.853h125.45M226.944 57.603h68.19M191.064 62.513c8.003 0 14.49-6.487 14.49-14.49s-6.487-14.49-14.49-14.49-14.49 6.488-14.49 14.49c0 8.003 6.488 14.49 14.49 14.49"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "successContactUsForm_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.185.033h377.63v198H.185z"
})))));
export default SvgSuccessContactUsForm;